export default __webpack_public_path__ + "static/media/corsair.7b71e1e7.png";